export const THDInputBaseStyles = {
    root: {
        fontSize: '1.4rem',
    },
    input: {
        '&::placeholder': {
            color: '#7A7978',
        },
    },
};
